import { useState, useEffect } from 'react';

const EntranceHeader = () => {
    const [componentAnimation, setComponentAnimation] = useState(false);

    useEffect(() => {
        setComponentAnimation(true);
    }, 10);

    return (
        <div className={`entranceHeader_wrapper ${componentAnimation ? 'active ' : ''}
            col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12`}>
            <div className="header_menu">
                <div className="header contain ">
                    <i className="icon-Group-4044" />
                    <span>Samsung Plus</span>
                </div>
            </div>
        </div>
    );
}

export default EntranceHeader;